import { Address } from "@/api/model"

export const buildFullAddressLine = (address: Address) => {
  return [
    address.addressLine1,
    address.addressLine2,
    address.addressLine3,
    address.postcode,
  ]
    .filter(Boolean)
    .join(", ")
}
